exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-image[data-v-6fd38ff2]{border:1px solid #133252}[data-v-6fd38ff2] .profile-image .image-alt{font-weight:400!important;font-size:60px!important}.border-gradient[data-v-6fd38ff2]{padding:1px;background:linear-gradient(270deg,#29b32f,#296db3)}@media only screen and (max-width:767px){.profile-image[data-v-6fd38ff2],[data-v-6fd38ff2] .profile-image .image-alt{width:48px!important;height:48px!important;font-size:25px!important}.fs-24[data-v-6fd38ff2]{font-size:20px}.fs-16[data-v-6fd38ff2]{font-size:14px}}", ""]);

// exports
